import React from "react";
import styles from "./booking-flow-primary-button.module.css";

type BookingFlowPrimaryButtonProps = {
    children: React.ReactNode;
    disabled?: boolean;
    loading?: boolean;
    onClick: () => void;
};

const BookingFlowPrimaryButton: React.FunctionComponent<BookingFlowPrimaryButtonProps> = ({
    children,
    disabled = false,
    loading = false,
    onClick,
}) => {
    return (
        <button
            type="button"
            className={styles.button}
            disabled={disabled || loading}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default BookingFlowPrimaryButton;
